import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from 'common-domain';
import {jwtDecode} from "jwt-decode";

@Component({
    selector: 'app-reset-password-complete',
    templateUrl: './reset-password-complete.component.html',
    styleUrls: ['./reset-password-complete.component.scss'],
    standalone: false
})
export class ResetPasswordCompleteComponent implements OnInit {
  correlationId: string;
  mfaToken: string;

  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router) {
  }

  ngOnInit() {
    if (!this.route.snapshot || !this.route.snapshot.paramMap) {
      this.goHome();
    } else {
      const token = this.route.snapshot.paramMap.get('token');
      this.correlationId = this.route.snapshot.paramMap.get('correlationId');
      const mfaCode = this.route.snapshot.paramMap.get('mfaCode');
      // @ts-ignore
      const userId = jwtDecode(token).sub;
      this.authService.validateResetPasswordToken(token, userId, mfaCode).subscribe({
        next: (result) => {
          if (result.additionalAuth && result.additionalAuth.toUpperCase() === "MFA") {
            this.router.navigateByUrl('/home/reset-password-mfa/' + token + '/' + this.correlationId);
          }
          if (result.mfaToken) {
            this.mfaToken = result.mfaToken.ref;
          } else {
            this.mfaToken = token;
          }
        },
        error: () => {
          this.goHome();
        }
      });
    }
  }

  goHome() {
    this.authService.redirectToHome('Token Invalid/Expired');
  }

  resetPasswordCompleted(completed: boolean) {
    if (completed) {
      this.authService.logout('Your credentials have been successfully updated, please login with your new username and password.', true);
    } else {
      this.authService.redirectToHome();
    }
  }
}
